export const isTrue = (value) => !!value || value === "true";
export const isFalse = (value) => !!value || value === "false";
